const profileData = [
    {
        id: 1.1,
        section: 'membership',
        field: 'TraceNet ID',
        field_key: 'apeda_code',
        type: 'text',
        desc: 'Please enter the Apeda / Tracenet code of the farmer.',
        // requiredField: true,
        non_editable: true,
    },
    {
        id: 1.2,
        section: 'membership',
        field: 'FTAK farmer code',
        field_key: 'membership_number',
        type: 'text',
        // requiredField: true,
        desc: 'Please enter the 8-digit FTAK farmer code of the farmer.',
        non_editable: true,
    },
    {
        id: 1.9,
        section: 'membership',
        field: 'MOA',
        field_key: 'moa',
        type: 'text',
        desc: 'Please enter the Government ID of the farmer.',
        // requiredField: true,
        non_editable: true,
    },
    {
        id: 1.3,
        section: 'membership',
        field: 'Date of Joining',
        field_key: 'date_of_joining',
        type: 'date',
        desc: 'Please select the date of joining of the farmer.',
    },
    {
        id: 1.4,
        section: 'membership',
        field: 'District',
        field_key: 'district',
        type: 'dropdown',
        dropdown_key: 'district',
        desc: 'Please select the Apeda registration district of the farmer.',
    },
    {
        id: 1.5,
        section: 'membership',
        field: 'Panchayat',
        field_key: 'panchayat',
        type: 'dropdown',
        dropdown_key: 'panchayat',
        desc: 'Please select the Apeda registration panchayat of the farmer.',
    },
    {
        id: 1.6,
        section: 'membership',
        field: 'Cell',
        field_key: 'cell',
        type: 'dropdown',
        dropdown_key: 'cell',
        desc: 'Please select the Apeda registration cell of the farmer.',
    },
    {
        id: 1.7,
        section: 'membership',
        field: 'SHG',
        field_key: 'shg',
        type: 'multi_dropdown',
        dropdown_key: 'shg',
        desc: 'Please select the SHG of the farmer.',
    },
    {
        id: 1.10,
        section: 'membership',
        field: 'ICS',
        field_key: 'ics',
        type: 'ics_table',
        dropdown_key: 'ics',
        desc: 'The ICS of the farmer.',
        table_headers: ['ICS name', 'Update date', 'Status'],
    },
    {
        id: 1.8,
        section: 'membership',
        field: 'FTAK Agreement',
        field_key: 'ftak_agreement',
        type: 'file',
        desc: 'Please upload the FTAK agreement.',
        requiredField: true
    },


    {
        id: 2.01,
        section: 'personal',
        field: 'First Name',
        field_key: 'first_name',
        type: 'text',
        requiredField: true,
        desc: 'Please enter the first name of the farmer.',
    },
    {
        id: 2.02,
        section: 'personal',
        field: 'Last Name',
        field_key: 'last_name',
        type: 'text',
        requiredField: true,
        desc: 'Please enter the last name of the farmer.',
    },
    {
        id: 2.3,
        section: 'personal',
        field: 'Mobile number',
        field_key: 'mobile_number',
        type: 'numeric',
        requiredField: true,
        desc: 'Please enter the mobile number of the farmer.',
    },
    {
        id: 2.4,
        section: 'personal',
        field: 'Date of birth',
        field_key: 'date_of_birth',
        type: 'date',
        requiredField: true,
        desc: 'Please select the date of birth of the farmer.',
    },
    {
        id: 2.5,
        section: 'personal',
        field: 'Gender',
        field_key: 'gender',
        type: 'dropdown',
        requiredField: true,
        dropdown_key:'gender',
        desc: 'Please select the gender of the farmer.',
    },
    {
        id: 2.6,
        section: 'personal',
        field: 'Religion',
        field_key: 'religion',
        type: 'dropdown',
        dropdown_key: 'religion',
        desc: 'Please select the religion of the farmer.',
    },
    {
        id: 2.22,
        section: 'personal',
        field: 'Caste',
        field_key: 'caste',
        type: 'dropdown',
        dropdown_key: 'caste',
        desc: 'Please select the caste of the farmer.',
    },
    {
        id: 2.7,
        section: 'personal',
        field: 'House Name/Number',
        field_key: 'house_name',
        type: 'text',
        desc: 'Please enter the house name / number of the farmer.',
    },

    {
        id: 2.8,
        section: 'personal',
        field: 'Address Line 1',
        field_key: 'address_line1',
        type: 'text',
        desc: 'Please enter the current residential/communication address of the farmer.',
    },
    {
        id: 2.9,
        section: 'personal',
        field: 'Address Line 2',
        field_key: 'address_line2',
        type: 'text',
        desc: 'Please enter the current residential/communication address of the farmer.',
    },
    {
        id: 2.10,
        section: 'personal',
        field: 'Do you know your Pincode?',
        field_key: 'pincode',
        type: 'pincode',
        // requiredField: true,
        desc: 'Please select YES if you know the pincode or select NO if you do not know.',
    },
    {
        id: 2.11,
        section: 'personal',
        field: 'District',
        field_key: 'district',
        type: 'dropdown',
        dropdown_key:'district',
        requiredField: true,
        desc: 'Please select the current residential/communication district of the farmer.',
    },
    {
        id: 2.12,
        section: 'personal',
        field: 'Taluk',
        field_key: 'taluk',
        type: 'dropdown',
        dropdown_key: 'taluk',
        requiredField: true,
        desc: 'Please select the current residential/communication taluk of the farmer.',
    },
    {
        id: 2.13,
        section: 'personal',
        field: 'Village',
        field_key: 'village',
        type: 'dropdown',
        dropdown_key: 'village',
        requiredField: true,
        desc: 'Please select the current residential/communication village of the farmer.',
    },
    {
        id: 2.14,
        section: 'personal',
        field: 'Locality',
        field_key: 'locality',
        type: 'dropdown',
        dropdown_key: 'locality',
        requiredField: true,
        desc: 'Please select the current residential/communication locality of the farmer.',
    },
    {
        id: 2.15,
        section: 'personal',
        field: 'Panchayat',
        field_key: 'panchayat',
        dropdown_key: 'panchayat',
        type: 'dropdown',
        desc: 'Please select the current residential/communication panchayat of the farmer.',
    },
    {
        id: 2.16,
        section: 'personal',
        field: 'Post Office',
        field_key: 'post_office',
        type: 'text',
        desc: 'Please enter the current residential/communication post office of the farmer.',
    },
    {
        id: 2.17,
        section: 'personal',
        field: 'Total Land Area Holding (including cultivated, uncultivated, certified/non certified)',
        field_key: 'total_land_area',
        type: 'numeric',
        requiredField: true,
        desc: 'Please enter the total land area of the farmer.',
    },
    {
        id: 2.18,
        section: 'personal',
        field: 'Total Land Area Unit',
        field_key: 'land_area_unit',
        type: 'dropdown',
        dropdown_key:'land_area_unit',
        requiredField: true,
        desc: 'Please select the unit of measurement for the area.',
    },
    {
        id: 2.19,
        section: 'personal',
        field: 'Adhaar Number',
        field_key: 'adhaar_number',
        type: 'numeric',
        requiredField: true,
        desc: 'Please enter the Adhaar card number of the farmer.',
    },
    {
        id: 2.20,
        section: 'personal',
        field: 'Adhaar card',
        field_key: 'adhaar_card',
        type: 'file',
        requiredField: true,
        desc: 'Please upload the Adhaar card.',
    },
    {
        id: 2.21,
        section: 'personal',
        field: 'Profile Image',
        field_key: 'profile_photo',
        type: 'file',
        requiredField: true,
        desc: 'Please upload the profile photo.',
    },
    
    {
        id: 3.10,
        section: 'financial',
        field: 'Bank Details',
        field_key: 'bank_details',
        type: 'bank_table',
        // desc: 'Please enter bank details.',
        table_headers: ['Account name', 'Account number', 'IFSC', 'Bank name', 'Branch', 'Address', 'Status', 'Action'],
        table_fields: [
            {
                field: 'Account name',
                field_key: 'account_name',
                type: 'text'
            },
            {
                field: 'Account number',
                field_key: 'account_number',
                type: 'numeric'
            },
            {
                field: 'IFSC',
                field_key: 'ifsc',
                type: 'text'
            },
            {
                field: 'Bank name',
                field_key: 'bank_name',
                type: 'text'
            },
            {
                field: 'Branch',
                field_key: 'bank_branch_name',
                type: 'text'
            },
            {
                field: 'Bank address',
                field_key: 'bank_address',
                type: 'text_area'
            },
            {
                field: 'Passbook front page',
                field_key: 'passbook_file',
                type: 'file'
            },
            ]
    },
    {
        id: 3.1,
        section: 'financial',
        field: 'Income from agriculture',
        field_key: 'income_agriculture',
        type: 'numeric',
        desc: 'Please enter the total income from agricultural sources of the farmer.',
    },
    {
        id: 3.2,
        section: 'financial',
        field: 'Income from other sources',
        field_key: 'income_other_sources',
        type: 'numeric',
        desc: 'Please enter the total income fromm other sources of the farmer.',
    },
    {
        id: 3.3,
        section: 'financial',
        field: 'Annual Income',
        field_key: 'annual_income',
        type: 'numeric',
        desc: 'Please enter the total annual income of the farmer.',
    },

    // {
    //     id: 3.4,
    //     section: 'financial',
    //     field: 'Account Name',
    //     field_key: 'account_name',
    //     type: 'text',
    //     desc: 'Please enter the banking account name of the farmer.',
    // },
    // {
    //     id: 3.5,
    //     section: 'financial',
    //     field: 'Account Number',
    //     field_key: 'account_number',
    //     type: 'numeric',
    //     desc: 'Please enter the bank account number of the farmer.',
    // },
    // {
    //     id: 3.6,
    //     section: 'financial',
    //     field: 'IFSC',
    //     field_key: 'ifsc',
    //     type: 'text',
    //     desc: 'Please enter the IFSC code of the bank.',
    // },
    // {
    //     id: 3.11,
    //     section: 'financial',
    //     field: 'Bank name',
    //     field_key: 'bank_name',
    //     type: 'text',
    //     desc: 'Please enter the name of the bank.',
    // },
    // {
    //     id: 3.7,
    //     section: 'financial',
    //     field: 'Bank Branch',
    //     field_key: 'bank_branch_name',
    //     type: 'text',
    //     desc: 'Please enter the branch name of the bank.',
    // },
    // {
    //     id: 3.8,
    //     section: 'financial',
    //     field: 'Bank Name and Address',
    //     field_key: 'bank_address',
    //     type: 'text_area',
    //     desc: 'Please enter the name and address of the bank.',
    // },
    // {
    //     id: 3.9,
    //     section: 'financial',
    //     field: 'Bank Passbook Front Page',
    //     field_key: 'passbook_file',
    //     type: 'file',
    //     desc: 'Please upload the bank passbook front page.',
    // },

   
    
    {
        id: 4.1,
        section: 'family',
        field: 'Martial Status',
        field_key: 'marital_status',
        type: 'bool',
        desc: 'Please select the martial status of the farmer.',

        // subfield1: 'Spouse name',
        // subfield1_key: 'spouse_name',
        // subfield1Type: 'text',
        // subfield2: 'Spouse age',
        // subfield2_key: 'spouse_age',
        // subfield2Type: 'numeric'
    },
    // {
    //     id: 4.2,
    //     section: 'family',
    //     field: 'Children',
    //     type: 'bool',
    //     subfield1: 'Child name',
    //     subfield1_key: 'child_name',
    //     subfield1Type: 'text',
    //     subfield2: 'Child age',
    //     subfield2_key: 'child_age',
    //     subfield2Type: 'numeric'
    // },
    // {
    //     id: 4.3,
    //     section: 'family',
    //     field: 'Other members',
    //     type: 'bool',
    //     subfield1: 'Relationship',
    //     subfield1_key: 'relationship',
    //     subfield1Type: 'text',
    //     subfield2: 'Employment status',
    //     subfield2_key: 'emp_status',
    //     subfield2Type: 'text'
    // },
    {
        id: 4.4,
        section: 'family',
        field: 'Family details',
        field_key: 'family_members',
        type: 'table',
        desc: 'Please enter the family member details.',
        table_headers: ['Name', 'Date of birth', 'Relationship', 'Education', 'Employment Status', 'Annual Income'],
        table_body: [
            {
                name:'name',
                type:'text'
            }, 
            {
                name:'dob',
                type:'date'
            },
            {
                name:'relationship',
                type:'dropdown',
                field_key: 'family_relationship', //for dropdown mapping
                dropdown_key:'family_relationship',
            },
            {
                name:'education',
                type:'dropdown', 
                field_key: 'education',
                dropdown_key:'education',
            },
            {
                name:'emp_status',
                type:'dropdown',
                field_key: 'employment_status',
                dropdown_key:'employment_status',
            },
            {
                name:'annual_income',
                type:'numeric'
            },
        ]
    },

    // {
    //     id: 5.1,
    //     section: 'animals',
    //     field: 'Animals',
    //     field_key: 'animals_present',
    //     type: 'bool',
    //     subfield1: 'Animals',
    //     subfield1_key: 'animals',
    //     subfield1Type: 'dropdown',
    //     subfield2: 'Count',
    //     subfield2_key: 'count',
    //     subfield2Type: 'numeric',
    //     subfield3: 'Purchased Date',
    //     subfield3_key: 'animal_purchase_date',
    //     subfield3Type: 'date'
    // },
    {
        id: 5.1,
        section: 'animals',
        field: 'Animals',
        field_key: 'animals_present',
        type: 'bool',
        desc: 'Please select whether animal present or not.',
    },
    {
        id: 5.2,
        section: 'animals',
        field: 'Animal details',
        field_key: 'animal_details',
        type: 'table',
        desc: 'Please enter animal details.',
        table_headers: ['ID', 'Animals', 'Breed', 'Count', 'Date of birth', 'Date of purchase', 'Age', 'Purchase amount', 'Status'],
        table_body: [
            {
                name: 'animal_id',
                type: ''
            },
            {
                name: 'animal_name',
                type: 'dropdown',
                field_key: 'animals',
                dropdown_key:'animals',
                subfield_key: 'breed' 
            }, 
            {
                name: 'breed',
                type: 'dropdown',
                field_key: 'breed',
                dropdown_key:'breed',
            },
            {
                name: 'count',
                type: 'numeric',
            }, 
            // {
            //     name: 'born_here',
            //     type: 'bool',
            // },
            {
                name: 'date_of_birth',
                type: 'date'
            },
            {
                name: 'animal_purchase_date',
                type: 'date'
            },
            {
                name: 'age',
                type: 'numeric'
            },
            {
                name: 'purchase_amount',
                type: 'numeric',
            },
            {
                name: 'status',
                type: 'toggle',
            },
             
        ]
    },
    
    // {
    //     id: 5.2,
    //     section: 'animals',
    //     field: 'Number of animals',
    //     type: 'dropdown',
    // },
    // {
    //     id: 5.3,
    //     section: 'animals',
    //     field: 'Date of entry',
    //     type: 'date',
    // },
    {
        id: 6.01,
        section: 'plots',
        field: 'Plot name | number',
        field_key: 'plot_number',
        type: 'text',
        desc: 'Please enter a unique name or number to identify plot.',
        requiredField: true
    },
    {
        id: 6.2,
        section: 'plots',
        field: 'Survey number',
        field_key: 'survey_number',
        type: 'text',
        desc: 'Please enter a survey number of the plot.',
        // requiredField: true
    },
    {
        id: 6.3,
        section: 'plots',
        field: 'Farming style',
        field_key: 'farming_style',
        type: 'dropdown',
        dropdown_key: 'farming_type',
        desc: 'Please select a the type of farming in this particular plot.',
    },
    {
        id: 6.4,
        section: 'plots',
        field: 'Certification',
        field_key: 'certification',
        type: 'multi_dropdown',
        dropdown_key: 'certification',
        desc: 'Please select the certification of this plot.',
    },
    {
        id: 6.11,
        section: 'plots',
        field: 'Organic land certification status',
        field_key: 'land_area_status',
        type: 'dropdown',
        dropdown_key: 'land_area_status',
        desc: 'Please select the organic certification status of this plot.',
    },
    {
        id: 6.5,
        section: 'plots',
        field: 'Area',
        field_key: 'area',
        type: 'numeric',
        desc: 'Please enter the total area of this plot.',
        requiredField: true
    },
    {
        id: 6.6,
        section: 'plots',
        field: 'Area unit',
        field_key: 'area_unit',
        type: 'dropdown',
        dropdown_key: 'uom',
        desc: 'Please select the unit of measurement for the area of this plot.',
    },
    {
        id: 6.7,
        section: 'plots',
        field: 'Latitude',
        field_key: 'latitude',
        type: 'numeric',
        desc: 'Please enter the latitude of this plot.',
    },
    {
        id: 6.8,
        section: 'plots',
        field: 'Longitude',
        field_key: 'longitude',
        type: 'numeric',
        desc: 'Please enter the longitude of this plot.',
    },
    {
        id: 6.9,
        section: 'plots',
        field: 'Land tax receipt',
        field_key: 'land_tax_receipt_file',
        type: 'file',
        desc: 'Please upload the land tax receipt for this plot.',
    },
    {
        id: 6.10,
        section: 'plots',
        field: 'Area polygon (Geo JSON)',
        field_key: 'geojson',
        type: 'geojson',
        desc: 'Please mark the points on the map to create a polygon of this plot.',
    },

    {
        id: 7.01,
        section: 'crops',
        field: 'Crop Name',
        field_key: 'crop_name',
        type: 'dropdown',
        dropdown_key: 'crops',
        desc: 'Please select the crop grown in this plot.',
        requiredField: true
    },
    {
        id: 7.11,
        section: 'crops',
        field: 'Organic land certification status',
        field_key: 'land_area_status',
        type: 'dropdown',
        dropdown_key: 'land_area_status',
        desc: 'Please select the organic certification status of this crop.',
    },
    {
        id: 7.4,
        section: 'crops',
        field: 'Total number of Yielding trees / plants',
        field_key: 'no_yielding_trees',
        type: 'numeric',
        desc: 'Please enter the total number of yielding trees present in this plot.',
    },
    {
        id: 7.5,
        section: 'crops',
        field: 'Total area of Yielding trees / plants',
        field_key: 'area_yielding_trees',
        type: 'numeric',
        desc: 'The total yielding area occupied by this crop in this plot - auto calculated based on the number of yielding trees count.',
        disabledField: true,
    },
    {
        id: 7.6,
        section: 'crops',
        field: 'Total number of Non-Yielding trees / plants',
        field_key: 'no_unyielding_trees',
        type: 'numeric',
        desc: 'Please enter the total number of non-yielding trees present in this plot.',
    },
    {
        id: 7.7,
        section: 'crops',
        field: 'Total area of Non-yielding trees / plants',
        field_key: 'area_unyielding_trees',
        type: 'numeric',
        desc: 'The total non-yielding area occupied by this crop in this plot - auto calculated based on the number of non-yielding trees count.',
        disabledField: true,
    },
    {
        id: 7.2,
        section: 'crops',
        field: 'Total number of trees / plants',
        field_key: 'total_trees',
        type: 'numeric',
        desc: 'Please enter the total number of trees present in this plot.',
        disabledField: true,
    },
    {
        id: 7.3,
        section: 'crops',
        field: 'Total area of the crop',
        field_key: 'total_area',
        type: 'numeric',
        desc: 'The total area occupied by this crop in this plot - auto calculated based on the number of trees count.',
        disabledField: true,
    },
    {
        id: 7.8,
        section: 'crops',
        field: 'Area unit',
        field_key: 'area_unit',
        type: 'dropdown',
        dropdown_key: 'uom_area',
        desc: 'Please select the unit of measurement for the area (Hectares by default).',
    },
    {
        id: 7.9,
        section: 'crops',
        field: 'Expected yield',
        field_key: 'expected_yield',
        type: 'numeric',
        desc: 'Please enter the total expected yield of this crop from this plot.',
    },
    {
        id: 7.12,
        section: 'crops',
        field: 'Actual yield (to be filled after harvest)',
        field_key: 'actual_yield',
        type: 'numeric',
        desc: 'Please enter the total actual yield of this crop after harvest from this plot.',
    },
    {
        id: 7.10,
        section: 'crops',
        field: 'Yield unit',
        field_key: 'yield_unit',
        type: 'dropdown',
        dropdown_key: 'uom_mass',
        desc: 'Please select the unit of measurement for the yield.',
    },
    
]

export default profileData;